<template>
    <div id="yummy" class="container pt-5">
        <div class="d-flex flex-column w-md-75 justify-content-center mx-auto text-center mb-md-5">
            <h2 class="pt-3 pt-lg-5">YUMMY GALAXY</h2>
            <p class="pt-3">
                Acum te poți juca cu personajele tale preferate pe telefonul mobil. Descarcă aplicația si explorează Universul Yummy!
            </p>
        </div>

        <img src="../../assets/imgs/landing/Yummy Galaxy Logo Transparent.png" alt="" id="yummy_logo">
        <div id="stores" class="container my-4">
            <a href="https://play.google.com/store/apps/details?id=com.gamify.asdl.yummy" target="_blank">
                <img src="../../assets/imgs/landing/google-en.png" alt="" id="android-store" class="m-1">
            </a>

            <a href="https://apps.apple.com/ro/app/yummy-galaxy/id1529570847" target="_blank">
                <img src="../../assets/imgs/landing/apple-en.png" alt="" id="ios-store" class="m-1">
            </a>
        </div>

        <div class="d-flex flex-column w-md-75 justify-content-center mx-auto text-center pt-5 my-md-5">
            <h2 class="pt-3 pt-lg-5">Ușile sunt deschise!</h2>

            <p class="pt-3">Te așteptăm într-o lume haioasă, plină de culoare și de aventură, cu medici pentru copii
                și îngrijire prietenoasă și profesionistă.</p>

            <login></login>

        </div>

    </div>
</template>

<script>
    import Login from "../partials/Login"

    export default {
        components: {
            Login
        },
        name: "Yummy"
    }
</script>

<style scoped>

    #yummy {
        width: 100%;
        margin: 0 auto;
        padding-top: 40px;
    }

    #yummy_logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 60%;
    }

    #android-store {
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        /*padding-right: 1%;*/
    }

    #ios-store {
        display: inline-block;
        /*padding-left: 1%;*/
        margin-left: auto;
        margin-right: auto;
    }
    #stores {
        width: 100%;
        padding-top: 30px;
        padding-bottom: 30px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
    }
</style>
